<template>
  <div class="notification">
    <div class="notification__text">
      <span v-html="notification.text"></span>
    </div>
    <div class="notification__close">
      <i class="material-icons" @click.stop="removeNotification()">icon_close</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: Object
  },
  methods: {
    removeNotification() {
      this.$store.dispatch('notifications_delete', this.notification.guid);
    }
  },
  created() {
    if (!this.notification.withAction) {
      setTimeout(() => {
        this.removeNotification();
      }, 10000);
    }
  }
};
</script>

<style lang="scss">
.notification {
  display: flex;
  gap: 12px;
  //width: fit-content;
  max-width: 400px;
  background: rgb(225, 249, 249);
  border-radius: 20px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
  padding: 4px 8px 12px 12px;
  margin: 8px 0;
  position: relative;
  color: #333;

  &__text {
    padding-top: 8px;
    color: #333;
    font-weight: 500;

    span {
      color: #333;
    }
  }

  &__close {

    color: #333;
    i{
      width: fit-content;
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
